import NextDividend from './NextDividend';

export default NextDividend;
